import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import ContactForm from "./contactform"
import Instagram from "../images/instagram.png"
import Facebook from "../images/fb.png"

const Footer = () => {
  const data = useStaticQuery(graphql`
    {
      contentfulHome {
        linkZuFacebookProfil
        linkZuInstagramProfil
      }
      contentfulFooter(id: { eq: "4c2a30e1-7771-528e-bafb-9b4e04614a36" }) {
        agbAnzeigen
        newsletterTitle
        newsletterText {
          childMarkdownRemark {
            html
          }
        }
        footerText {
          childMarkdownRemark {
            html
          }
        }
        copyrightText {
          childMarkdownRemark {
            html
          }
        }
      }
      wanderreisen: allContentfulReise(
        filter: { typ: { eq: "Wanderreise" } }
        sort: { fields: destination, order: ASC }
      ) {
        edges {
          node {
            destination
            land
            slug
          }
        }
      }
      segelkreuzfahrten: allContentfulReise(
        filter: { typ: { eq: "Segel-Kreuzfahrt" } }
        sort: { fields: destination, order: ASC }
      ) {
        edges {
          node {
            destination
            land
            slug
          }
        }
      }
      golfreisen: allContentfulReise(
        filter: { typ: { eq: "Golfreise" } }
        sort: { fields: destination, order: ASC }
      ) {
        edges {
          node {
            destination
            land
            slug
          }
        }
      }
      blog: allContentfulBlogPost(sort: { fields: updatedAt, order: DESC }) {
        edges {
          node {
            title
            slug
          }
        }
      }
    }
  `)
  return (
    <footer>
      <div className="newsletter">
        <h4>{data.contentfulFooter.newsletterTitle}</h4>
        <div className="newsletter-form">
          <div
            className="newsletter-text"
            dangerouslySetInnerHTML={{
              __html:
                data.contentfulFooter.newsletterText.childMarkdownRemark.html,
            }}
          ></div>
          <ContactForm />
        </div>
      </div>
      <section className="flex gap-8 justify-center align-middle">
        <div>
          <a
            href={data.contentfulHome.linkZuInstagramProfil}
            target="_blank"
            rel="noreferrer"
          >
            <img className="h-8 w-8" src={Instagram} alt="Instagram"></img>
          </a>
        </div>
        <div>
          <a
            href={data.contentfulHome.linkZuFacebookProfil}
            target="_blank"
            rel="noreferrer"
          >
            <img className="h-8 w-8" src={Facebook} alt="Facebook"></img>
          </a>
        </div>
      </section>

      <div
        className="footer-text"
        dangerouslySetInnerHTML={{
          __html: data.contentfulFooter.footerText.childMarkdownRemark.html,
        }}
      ></div>
      <div className="sitemap">
        <div className="sitemap-wanderreisen">
          <h5>Wanderreisen</h5>
          <ul>
            {data.wanderreisen.edges.map((reise) => (
              <li key={reise.node.slug}>
                <Link
                  to={
                    "/wanderreisen/" +
                    reise.node.land.toLowerCase() +
                    "/" +
                    reise.node.slug
                  }
                >
                  {reise.node.destination}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="sitemap-golfreisen">
          <h5>Golfreisen</h5>
          <ul>
            {data.golfreisen.edges.map((reise) => (
              <li key={reise.node.slug}>
                <Link
                  to={
                    "/golfreisen/" +
                    reise.node.land.toLowerCase() +
                    "/" +
                    reise.node.slug
                  }
                >
                  {reise.node.destination}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="sitemap-segelkreuzfahrten">
          <h5>Segelkreuzfahrten</h5>
          <ul>
            {data.segelkreuzfahrten.edges.map((reise) => (
              <li key={reise.node.slug}>
                <Link
                  to={
                    "/segelkreuzfahrten/" +
                    reise.node.land.toLowerCase() +
                    "/" +
                    reise.node.slug
                  }
                >
                  {reise.node.destination}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="sitemap-blog">
          <h5>Blog</h5>
          <ul>
            {data.blog.edges.map((blog) => (
              <li key={blog.node.slug}>
                <Link to={"/blog/" + blog.node.slug}>{blog.node.title}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="sitemap-uber">
          <h5>Über Uns</h5>
          <ul>
            <li>
              <Link to="/ueber-uns">Bärkopf</Link>
            </li>
            <li>
              <Link to="/bewertungen">Bewertungen</Link>
            </li>

            <li>
              <a href="https://freizeitleben.at">FreiZeitLEBEN</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="copyright-container">
        <Link to="/impressum">Impressum</Link>
        <Link to="/datenschutz">Datenschutzrichtlinie</Link>
        {data.contentfulFooter.agbAnzeigen && <Link to="/agb">AGB</Link>}
      </div>
      <div
        className="copyright"
        dangerouslySetInnerHTML={{
          __html: data.contentfulFooter.copyrightText.childMarkdownRemark.html,
        }}
      ></div>
    </footer>
  )
}
export default Footer
